import { createAction, props } from '@ngrx/store';
import { CentralBranchGridGroup } from 'src/app/shared/models/message-hub/centralBranchGridGroupRequest';

export const setCentralLocationGridTenantId = createAction(
    '[Central Location View] Set Central Location Grid Tenant Id',
    props<{ tenantId: number }>()
);

export const setCentralLocationGridLocationId = createAction(
    '[Central Location View] Set Central Location Grid Location Id',
    props<{ locationId: number }>()
);

export const setCentralLocationGridPage = createAction(
    '[Central Location View] Set Central Location Grid Page',
    props<{ page: number, pageSize: number }>()
);

export const setCentralLocationGridSort = createAction(
    '[Central Location View] Set Central Location Grid Sort Column',
    props<{ sortColumn: string, sortDirection: string }>()
);

export const subscribeToCentralLocationGridData = createAction(
    '[Central Location View] Subscribe To Central Location Grid Data',
    props<{ centralGridViewFilter: CentralBranchGridGroup }>()
);

export const reSubscribtionToCentralLocationGridData = createAction(
    '[Central Location View] Reload Subscribtion To Central Location Grid Data'
);
